import { render, staticRenderFns } from "./BoletoDetail.vue?vue&type=template&id=4dec1558"
import script from "./BoletoDetail.vue?vue&type=script&lang=js"
export * from "./BoletoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports